import { randomId } from "../../helpers/random";
export class PortalContainer {
    constructor() {
        this.portals = new Map();
        this.listeners = [];
    }
    render(container, component) {
        var _a;
        const portal = this.portals.get(container);
        this.portals.set(container, { key: (_a = portal === null || portal === void 0 ? void 0 : portal.key) !== null && _a !== void 0 ? _a : randomId(), component });
        this.update();
    }
    remove(container) {
        this.portals.delete(container);
        this.update();
    }
    update() {
        // update is scheduled as a timeout so it runs as a delayed task
        // this is necessary to call listeners once instead of N times being N the number of portals (plugins + node views)
        // this improves performance particularly for react <=17 that doesn't batch state updates
        if (this.updatedTimeout) {
            window.clearTimeout(this.updatedTimeout);
        }
        this.updatedTimeout = window.setTimeout(() => {
            this.listeners.forEach((callback) => callback(this.portals));
        });
    }
    subscribe(callback) {
        this.listeners.push(callback);
        return () => {
            this.listeners = this.listeners.filter((listener) => listener !== callback);
        };
    }
    entries() {
        return Array.from(this.portals.entries());
    }
}
